import firebase from 'firebase'
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
      name: '',
      surname: '',
      birth: '',
      phone: 0,
      image: '',
      file: null,
      needImageUpdate: false

    }
  },
  computed: {
    ...mapGetters([
      'userProfile'
    ])
  },
  methods: {
    updateProfile () {
      const user = {
        userId: firebase.auth().currentUser.uid,
        name: this.name,
        surname: this.surname,
        birth: this.birth,
        phone: this.phone,
        needImageUpdate: this.needImageUpdate,
        photoProfile: this.file
      }
      this.$store.dispatch('updateUserProfile', user)
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      this.file = file
      const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
      this.needImageUpdate = true
    },
    removeImage (e) {
      this.image = ''
    }
  },
  mounted: function () {
    // Check if the user exists in collection users
    // Get user id
    const currentUser = firebase.auth().currentUser
    this.$store.dispatch('getUserInfo', currentUser).then(res => {
      console.log(this.userProfile)
      this.name = this.userProfile.name
      
      this.surname = this.userProfile.surname
      this.birth = this.userProfile.birth
      this.phone = this.userProfile.phone
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/Ovr/profile/profile.js